export default ({ data, dateKey, start, end }) => {
  const clampedData = data.filter((point) => point[dateKey] >= start && point[dateKey] <= end);
  return clampedData;
};
